import { h } from '@utils/html.js'
import throttle from 'lodash-es/throttle.js'
import { slideTo } from '@utils/animation.js'
import { trackEvent } from '../../modules/tracking/tracking'
import { currentHeaderHeight } from '../../modules/header/header'
;(async function () {
    const wrapper = document.querySelector('*[data-progress-start]')

    if (!wrapper) {
        return
    }

    let end = null

    const bar = h(`
      <div class="page-progress-bar tw-bg-gray-200" style="--progress: 0"></div>
    `)

    const linkStack = []

    wrapper.querySelectorAll('*[data-progress-link]').forEach((el) => {
        el.addEventListener('click', (e) => {
            console.log('here')
            const href = el.getAttribute('href')
            if (!href) return
            e.preventDefault()
            linkStack.push(
                window.scrollY || document.body.scrollTop || document.documentElement.scrollTop,
            )
            trackEvent('progress_link_click', {
                label: el.textContent.trim(),
            })
            slideTo(href, -1 * currentHeaderHeight(true))
        })
    })

    const onResize = () => {
        end = wrapper.offsetHeight
    }

    const throttledOnResize = throttle(function () {
        onResize()
    }, 300)
    onResize()

    const resizeObserver = new ResizeObserver(() => {
        throttledOnResize()
    })
    resizeObserver.observe(wrapper)
    const mutationObserver = new MutationObserver(() => {
        throttledOnResize()
    })
    mutationObserver.observe(wrapper, {
        attributes: false,
        childList: true,
        subtree: true,
    })

    const el = h(`
        <div
            class="tw-sticky !tw-z-10 tw-left-0 tw-w-full tw-rounded-full tw-h-0.5 print:tw-hidden sticky-below-header"
        ></div>`)

    el.append(bar)

    document.querySelector('#page-wrapper').prepend(el)

    window.addEventListener('scroll', () => {
        const scroll = window.scrollY

        window.requestAnimationFrame(() => {
            const percentage = (scroll / (end - window.innerHeight)) * 100

            if (percentage >= 100) {
                bar.style.setProperty('--progress', '100%')
                return
            }
            bar.style.setProperty('--progress', `${percentage}%`)
        })
    })
})()
